<!-- Overlay: cobre a tela sem desmontá-la, senão os botões que a Tuna injeta
     nos containers de wallet são destruídos junto e não voltam. -->
<div class="loading-overlay" *ngIf="loading">
  <app-loading [text]="pollingMessage"></app-loading>
</div>

<div class="page-container" *ngIf="table">
  <app-bar
    [title]="pageTitle"
    [backButtonProps]="backButtonProps"
    (backButtonClick)="handleBackButtonClick()"
  ></app-bar>

  <div class="page-content">
    <!-- Métodos de pagamento -->
    <section class="page-section border-bottom gap-2">
      <h2 class="title-large">
        Como quer pagar?
      </h2>
      <div class="payment-items-container">
        <!-- TODO: VALIDAR PAGAMENTO APÓS MERGE COM BRANCH DO EDEN -->
        @for(method of mappedPayments; track method.name) {
          @if(method.name === 'APPLE_PAY') {
            @if(walletContainersVisible) {
              <!-- Container para Apple Pay - sempre no DOM para permitir a montagem do botão, oculto até estar pronto -->
              <div #applePayFinalContainer
                id="applePayFinalContainer"
                class="wallet-container apple-pay-container payment-item"
                [style.display]="applePayReady ? '' : 'none'"
                [class.payment-item-selected]="selectedPayment?.name === method.name"
                aria-label="Finalizar pagamento com Apple Pay">
              </div>
            }
          } @else if(method.name === 'GOOGLE_PAY') {
            @if(walletContainersVisible) {
              <!-- Container para Google Pay - sempre no DOM para permitir a montagem do botão, oculto até estar pronto -->
              <div #googlePayFinalContainer
                id="googlePayFinalContainer"
                class="payment-item google-pay-container"
                [style.display]="googlePayReady ? '' : 'none'"
                [class.payment-item-selected]="selectedPayment?.name === method.name"
              >
                <div class="payment-item-title">
                  <mnt-icon [icon]="method.icon" size="medium"></mnt-icon>
                  <span>{{ method.displayName }}</span>
                </div>
              </div>
            }
          } @else {
            <!-- Métodos de pagamento normais (PIX, etc) -->
            <div class="payment-item"
              (click)="handleChangePaymentMethod(method)"
              [class.payment-item-selected]="selectedPayment?.name === method.name">
              <div class="payment-item-title">
                <mnt-icon [icon]="method.icon" size="medium"></mnt-icon>
                <span>{{ method.displayName }}</span>
              </div>

              <mnt-badge
                *ngIf="method.discount && method.nfceType === 17"
                color="primary"
                tone="highlight"
                [label]="method.discountText"
                size="tiny"
                icon="satisfied">
              </mnt-badge>
            </div>
          }
        }
      </div>
    </section>

    <!-- Módulo: Cupom -->
    <section class="page-section gap-2 w-100 mt-3" *ngIf="hasVoucher">
      <div class="custom-field-text-container w-100">
        <mnt-field-text
          full-width
          size="large"
          name="voucher"
          label-text="Cupom"
          placeholder="Digite o cupom"
          [value]="voucherInputValue || ''"
          (input)="handleVoucherInput($event)"
          [state]="voucherInputStatus"
          [inlineMessage]="voucherInputMessage"
          #voucherInput
        ></mnt-field-text>
        <mnt-button
          *ngIf="voucherAppliedId !== 0"
          [label]="loadingVoucher ? '' : 'Remover'"
          size="small"
          variant="stroke"
          (buttonClick)="handleVoucherRemove()"
          [iconLeft]="loadingVoucher ? 'loading' : ''"
          class="loading-icon"
        ></mnt-button>
        <mnt-button
          *ngIf="voucherAppliedId === 0"
          [disabled]="!voucherInputValue || voucherInputValue.length === 0"
          [label]="loadingVoucher ? '' : 'Aplicar'"
          size="small"
          variant="stroke"
          (buttonClick)="handleVoucherApply()"
          [iconLeft]="loadingVoucher ? 'loading' : ''"
          class="loading-icon"
        ></mnt-button>
      </div>
    </section>

    <!-- Módulo: Cashback -->
    <section class="page-section gap-2 w-100 border-bottom" *ngIf="hasCashback && (cashbackBalance > 0 || (table.cashbackApplied ?? 0) > 0 || canEarn)">
      <div class="d-flex align-center gap-1 mt-2 w-100">
        <h3 class="title-large m-0">
          Cashback
        </h3>

        <mnt-tooltip text="O valor é acumulativo para você usar quando quiser, respeitando o prazo de validade." position="top">
          <mnt-button-icon
            icon="info"
            size="small"
            color="neutral"
            variant="plain"
            size="small"
            slot="trigger"
          >
          </mnt-button-icon>
        </mnt-tooltip>

      </div>
      <label *ngIf="(cashbackBalance > 0 && !belowMinimumRedeemValue) || (table.cashbackApplied ?? 0) > 0" class="cashback-option" (click)="handleCashbackChange()">
        <div class="cashback-check" [class.checked]="useCashback">
          <mnt-icon *ngIf="useCashback" icon="check" size="small"></mnt-icon>
        </div>
        <span class="cashback-option-label">{{ cashbackLabel }}</span>
      </label>
      <div *ngIf="belowMinimumRedeemValue && (table.cashbackApplied ?? 0) === 0" class="message-highlight message-highlight-warning">
        <mnt-icon icon="signalingWarningTriangle" size="small"></mnt-icon>
        <span>
          {{ cashbackLabel }}
        </span>
      </div>
      <div *ngIf="canEarn && cashbackBalance === 0 && (table.cashbackApplied ?? 0) === 0" class="message-highlight message-highlight-success">
        <mnt-icon icon="signalingInfoCircle" size="small"></mnt-icon>
        <span>
          {{ cashbackLabel }}
        </span>
      </div>
    </section>

    <section class="page-section gap-2 w-100 mt-3">
      <app-table-values-summary-list
        [hasCashback]="table.cashbackApplied > 0"
        [cashbackValue]="table.cashbackApplied"
        [showPaymentMethodDiscount]="true"
        [subtotal]="table.paymentType === 'CUSTOM' ? null : getSubtotal()"
        [total]="table.paymentType === 'CUSTOM' ? null : getTotal()"
        [remainingValue]="getRemainingValue()"
      ></app-table-values-summary-list>
    </section>
  </div>
  <div class="page-footer d-column gap-3 mt-auto">
    <mnt-button
      variant="emphasis"
      color="primary"
      size="large"
      label="Pagar e concluir"
      full-width
      [disabled]="!selectedPayment"
      (buttonClick)="handleContinueButtonClick()"
    ></mnt-button>
  </div>
</div>